import Vue from 'vue'
import Router from 'vue-router'

import { Auth } from '@/services'

import Login from '@/components/login/Login'
import Layout from '@/components/Layout'

import PatientLayout from '@/components/patient/PatientLayout'
import PatientBoard from '@/components/patient/PatientBoard'
import PatientCreate from '@/components/patient/PatientCreate'
import PatientEdit from '@/components/patient/PatientEdit'
import PatientDetail from '@/components/patient/PatientDetail'

import ReservationLayout from '@/components/reservation/ReservationLayout'
import ReservationCreate from '@/components/reservation/ReservationCreate'
import ReservationEdit from '@/components/reservation/ReservationEdit'
import ReservationCancelNow from '@/components/reservation/ReservationCancelNow'
import ReservationHistoryLog from '@/components/reservation/ReservationHistoryLog'

import CaregiverLayout from '@/components/caregiver/CaregiverLayout'
import CaregiverCreate from '@/components/caregiver/CaregiverCreate'
import CaregiverBoard from '@/components/caregiver/CaregiverBoard'
import CaregiverDetail from '@/components/caregiver/CaregiverDetail'
import CaregiverEdit from '@/components/caregiver/CaregiverEdit'

import BookingLayout from '@/components/booking/BookingLayout'
import BookingCreate from '@/components/booking/BookingCreate'
import BookingEdit from '@/components/booking/BookingEdit'

import MatchingLayout from '@/components/matching/MatchingLayout'
import MatchingBoard from '@/components/matching/MatchingBoard'

import CaregiverLeaveLayout from '@/components/leave/CaregiverLeaveLayout'
import CaregiverLeaveForm from '@/components/leave/CaregiverLeaveForm'

import ChatLayout from '@/components/chat/ChatLayout'
import ChatBoard from '@/components/chat/ChatBoard'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    { path: '/',
      name: 'Login',
      component: Login,
      beforeEnter (to, from, next) {
        Auth.profile()
          .then((res) => {
            res.id && next('/patient/?tab=total')
          })
          .catch(() => {
            next()
          })
      },
    },
    { path: '/logout',
      beforeEnter: function (to, from, next) {
        Auth.signout()
          .then(() => {
            if (window.OneSignal) {
              window.OneSignal.deleteTags(['adminId', 'signedIn'])
            }
            next('/')
          })
          .catch(() => {
            next('/')
          })
      },
    },
    { path: '',
      component: Layout,
      children: [
        { path: '', redirect: '/patient' },
        { path: '/patient',
          component: PatientLayout,
          beforeEnter (to, from, next) {
            Auth.profile()
              .then((res) => {
                if (window.OneSignal) {
                  window.OneSignal.sendTags({
                    adminId: res.id,
                    signedIn: '1',
                  })
                }
                res.id && next()
              })
              .catch(() => {
                next('/')
              })
          },
          children: [
            { path: '', name: 'PatientBoard', component: PatientBoard, props: (route) => ({ tabSelected: route.query.tab }) },
            { path: 'create', name: 'PatientCreate', component: PatientCreate },
            { path: ':id', name: 'PatientDetail', component: PatientDetail, props: (to) => ({ id: +to.params.id, tabSelected: to.query.tab }) },
            { path: ':id/edit', name: 'PatientEdit', component: PatientEdit, props: (to) => ({ id: +to.params.id, navigateTo: 'PatientDetail' }) },
            { path: ':id/reservation',
              component: ReservationLayout,
              children: [
                { path: '', redirect: 'create' },
                { path: 'create', name: 'ReservationCreate', component: ReservationCreate, props: (to) => ({ id: +to.params.id, from: 'customer' }) },
                { path: ':reservationId/edit', name: 'ReservationEdit', component: ReservationEdit, props: (to) => ({ reservationId: +to.params.reservationId }) },
                { path: ':reservationId/cancel', name: 'ReservationCancelNow', component: ReservationCancelNow, props: (to) => ({ id: +to.params.id, reservationId: +to.params.reservationId }) },
                { path: ':reservationId/historylog', name: 'ReservationHistoryLog', component: ReservationHistoryLog, props: (to) => ({ id: +to.params.id, reservationId: +to.params.reservationId }) },
                { path: ':reservationId/booking',
                  component: BookingLayout,
                  children: [
                    { path: '', redirect: 'create' },
                    { path: 'create', name: 'BookingCreate', component: BookingCreate, props: (to) => ({ reservationId: +to.params.reservationId, patientId: +to.params.id }) },
                    { path: ':bookingId/edit', name: 'BookingEdit', component: BookingEdit, props: (to) => ({ reservationId: +to.params.reservationId, patientId: +to.params.id, id: +to.params.bookingId }) },
                    { path: ':bookingId/matching',
                      component: MatchingLayout,
                      children: [
                        { path: '', name: 'MatchingBoard', component: MatchingBoard, props: (to) => ({ reservationId: +to.params.reservationId, patientId: +to.params.id, id: +to.params.bookingId }) },
                      ],
                    },
                    { path: ':bookingId/leave',
                      component: CaregiverLeaveLayout,
                      children: [
                        { path: '', name: 'CaregiverLeaveForm', component: CaregiverLeaveForm, props: (to) => ({ reservationId: +to.params.reservationId, patientId: +to.params.id, id: +to.params.bookingId }) },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: '/caregiver',
          component: CaregiverLayout,
          beforeEnter (to, from, next) {
            Auth.profile()
              .then((res) => {
                res.id && next()
              })
              .catch(() => {
                next('/')
              })
          },
          children: [
            { path: '', name: 'CaregiverBoard', component: CaregiverBoard },
            { path: 'create', name: 'CaregiverCreate', component: CaregiverCreate },
            { path: ':id/edit', name: 'CaregiverEdit', component: CaregiverEdit, props: (to) => ({ id: +to.params.id }) },
            { path: ':id', name: 'CaregiverDetail', component: CaregiverDetail, props: (to) => ({ id: +to.params.id, tabSelected: to.query.tab }) },
          ],
        },
        {
          path: '/chat',
          component: ChatLayout,
          beforeEnter (to, from, next) {
            Auth.profile()
              .then((res) => {
                res.id && next()
              })
              .catch(() => {
                next('/')
              })
          },
          children: [
            { path: '', name: 'ChatBoard', component: ChatBoard, props: (route) => ({ lineid: route.query.id }) },
          ],
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})
